import * as React from "react";
import * as ReactDom from "react-dom";

import { InteractiveSearchForm } from "./InteractiveSearch.react";
import * as Url from "url";

export default function main(el: HTMLElement) {
	const searchForm = el.querySelector("form");
	const applicationData = JSON.parse(el.querySelector("script[data-select=applicationDataSearch]")?.textContent ?? "");
	const applicationRoot = el.querySelector("[data-select=interactiveSearchRoot]")
	const searchTerm = new URL(window.location.href).searchParams.get("searchTerm") ?? "";

	ReactDom.render(
		React.createElement(
			InteractiveSearchForm,
			{
				endpointUri: applicationData['endpointUri'],
				language: applicationData['language'],
				searchTerm: searchTerm
			}
		),
		applicationRoot
	);
}
